import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { LORAX } from 'HubStyleTokens/colors';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILogo from 'UIComponents/image/UILogo';
import { useUnloadAlert } from '../hooks/useUnloadAlert';
import { getHubSpotDotComLink } from '../hublets/hubletSelectionUtils';
import { getFlowKey } from '../routing/getFlowKey';
import { getCurrentStep } from '../store/flow/selectors';
import { devices } from '../styles/viewports.styles';
import { useTracker } from '../tracking/useTracker';
import { AcademyLogo } from './AcademyLogo';
import { ConnectLogo } from './ConnectLogo';
import { HubSpotForXLogo } from './HubSpotForXLogo';
const HubSpotWordmark = styled(UILogo).withConfig({
  displayName: "HubSpotLogo__HubSpotWordmark",
  componentId: "sc-11u9r0c-0"
})(["display:none;@media ", "{display:inline-block;width:8rem;}"], devices.desktop);
const HubSpotSprocket = styled(UIIcon).withConfig({
  displayName: "HubSpotLogo__HubSpotSprocket",
  componentId: "sc-11u9r0c-1"
})(["width:27px;height:27px;transform:translateY(7px);", " @media ", "{display:none !important;}"], props => props.flowkey === Flow.Connect && `display:none !important;`, devices.desktop);
const flowsWithSpecificLogos = {
  [Flow.HubspotForNonprofits]: /*#__PURE__*/_jsx(HubSpotForXLogo, {}),
  [Flow.Connect]: /*#__PURE__*/_jsx(ConnectLogo, {}),
  [Flow.Academy]: /*#__PURE__*/_jsx(AcademyLogo, {})
};

const HubSpotLogo = () => {
  const flowKey = getFlowKey();
  const Tracker = useTracker();
  const currentStep = useSelector(getCurrentStep);
  const {
    unloadAlert
  } = useUnloadAlert();

  const onClick = () => {
    unloadAlert.addAlert();
    Tracker.signupInteraction('click-hubspot-company-logo', {
      currentStep
    }, true);
    window.location.href = getHubSpotDotComLink();
  };

  const hubSpotLogo = /*#__PURE__*/_jsx(HubSpotWordmark, {
    alt: "Hubspot",
    name: "hubspot-wordmark",
    width: "128"
  });

  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      onClick: onClick,
      children: [flowsWithSpecificLogos[flowKey] ? flowsWithSpecificLogos[flowKey] : hubSpotLogo, /*#__PURE__*/_jsx(HubSpotSprocket, {
        color: LORAX,
        flowkey: flowKey,
        name: "sprocket",
        size: 27
      })]
    })
  });
};

export default HubSpotLogo;